export default [
  'packos',
  'keepup',
  'workboost',
  'logicprint5',
  'logicprint7',
  'logicprint7dollies',
  'goodin',
  'goodin-qa',
  'bucketservice',
  'knowlake',
  'lib',
  'hub',
  'cockpit',
];
